import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import ROUTES from "src/constants/system/routes";
import { useAuth } from '@redtrack/auth-core';

function GuestGuard({ children }) {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return <Navigate to={ROUTES.ROOT.INDEX.URL()} replace />;
  }

  return children;
}

GuestGuard.propTypes = {
  children: PropTypes.node.isRequired,
};

export default GuestGuard;
